import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import Link from 'next/link'
import React from 'react'

type IProps = {
  href: string
  title: string
  subtitle: string
}

const CrossLink = ({ href, title, subtitle }: IProps) => (
  <div className="flex w-full justify-center bg-cream-300 px-5 py-12 md:py-16">
    <Link
      href={href}
      className="group flex w-full max-w-3xl items-center justify-between gap-4 rounded-2xl border border-blue-400/30 bg-gradient-to-r from-blue-500 to-blue-600 p-5 text-white-500 transition-colors duration-200 hover:to-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 md:p-6"
    >
      <div>
        <p className="text-base font-semibold md:text-lg">{title}</p>
        <p className="mt-0.5 text-sm text-white-500/70">{subtitle}</p>
      </div>
      <ArrowForwardIcon className="shrink-0 text-xl transition-transform duration-200 group-hover:translate-x-1" />
    </Link>
  </div>
)

export default React.memo(CrossLink)
